import { createLegacyModule } from "./createLegacyModule";

const keys = [
  "Activity Service Terms",
  "Account cancellation agreement",
  "Account detection",
  "bindSuccess",
  "Cancel",
  "Confirm",
  "Enter a correct Phone Number",
  "Identity verification",
  "phone number",
  "Please enter the phone number",
  "Sign in and receiving WhatsApp Message"
];

export default createLegacyModule(keys);
